import {MessageBox} from 'element-ui';
import storage from 'local-storage-fallback';
import {getQueryString} from './helper';

const hostname = location.hostname.toLocaleLowerCase();
const isCustomDomain = hostname.indexOf(process.env.DOMAIN) === -1 && hostname.indexOf('lbx.com') === -1 && hostname.indexOf('weixiule.com') === -1;

function getSubDomain() {
  if (isCustomDomain) {
    return hostname.replace(/\./ig, '_');
  }

  const splitPart = hostname.split('.');
  if (splitPart.length < 3) {
    return 'www';
  }
  return splitPart[0].toLowerCase();
}

function getSpId() {
  return getQueryString('id');
}

function getSession() {
  const sessionString = storage.getItem((isCustomDomain ? getSubDomain() : (getSpId() || getSubDomain())) + 'session');
  if (!sessionString) {
    return null;
  }

  const session = JSON.parse(sessionString);
  if (!session || !session.access_token) {
    return null;
  }

  return session;
}

function extractAccessToken() {
  const session = getSession();
  if (!session) {
    return null;
  }
  return session.access_token;
}

function url_base64_decode(str) {
  let output = str.replace(/-/g, '+').replace(/_/g, '/');
  switch (output.length % 4) {
    case 0:
      break;
    case 2:
      output += '==';
      break;
    case 3:
      output += '=';
      break;
    default:
      throw 'Illegal base64url string!';
  }
  const result = window.atob(output);
  try {
    return decodeURIComponent(escape(result));
  } catch (err) {
    return result;
  }
}

function delete_cookie(name) {
  document.cookie = name + '=; Path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

export function getAuthInfo() {
  const accesstoken = extractAccessToken();
  if (!accesstoken) {
    logoutAndShowLogin();
    return null;
  }

  const accessTokenParts = accesstoken.split('.');
  const jwt = JSON.parse(url_base64_decode(accessTokenParts[1]));

  if (jwt.exp < Date.now() / 1000) {
    logoutAndShowLogin();
    return null;
  }

  if (!jwt.tmm) {
    logoutAndShowLogin();
    return null;
  }

  jwt.access_token = accesstoken;
  return jwt;
}

function removeSession() {
  storage.removeItem((getSpId() || getSubDomain()) + 'session');
  delete_cookie('.AspNetCore.Identity.Application');
  delete_cookie('idsrv.session');
}

export function logoutAndShowLogin() {
  removeSession();

  const windowWidth = $(window).width();
  if (windowWidth <= 430) {
    window.location.href = process.env.BASE_WEB + '/login2.html?login_type=1&id=' + getSpId() + '&domain_name=' + getSubDomain();
    return;
  }

  layer.open({
    type: 2,
    shade: 0.8,
    title: false,
    fixed: false,
    area: ['400px', '500px'],
    content: '/login2.html?login_type=1&id=' + getSpId() + '&domain_name=' + getSubDomain()
  });
}

export function logout() {
  MessageBox.confirm('确定要退出系统吗?', '请确认', {center: true}).then(function () {
    removeSession();
    window.location.href = '/';
  });
}



// WEBPACK FOOTER //
// ./src/utils/auth.js